import { LitElement, css, html, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators';

import { palette } from '../style/variables';

@customElement('error-page-fragment')
export class ErrorPageFragment extends LitElement {
    @property({ type: String })
    heading?: string;

    @property({ type: String })
    description?: string;

    private myMapsClick() {
        window.location.assign(`/#home`);
    }

    private visitCenterClick() {
        window.location.assign(`mailto:help@proxi.co`);
    }

    render() {
        return html`
            <div class="fullContainer">
                <div class="leftContainer">
                    <h1 class="heading">${this.heading}</h1>
                    <p class="description">${this.description}</p>
                    <img src="/images/arrow.svg" class="arrowImg" alt="arrow" />
                    <div class="buttonsWrapper">
                        <form-button
                            class="myMapsBtn buttonItem"
                            size="lg"
                            @click="${this.myMapsClick}"
                            >My Maps</form-button
                        >
                        <form-button
                            class="helpCenterBtn buttonItem"
                            size="lg"
                            @click="${this.visitCenterClick}"
                            >Contact Our Team</form-button
                        >
                    </div>
                </div>
                <div class="rightContainer">
                    <img src="/images/hero-signin.png" class="lockImg" alt="arrow" />
                </div>
            </div>
            <error-toast id="errorToast"></error-toast>
        `;
    }

    static get styles() {
        return css`
            .fullContainer {
                min-height: 100vh;
                background: var(--theme-border-color);
                display: flex;
            }

            .leftContainer {
                width: 55%;
                background: var(--theme-input-color);
                padding: 10vh 5vw 10vh 7.5vw;
                box-sizing: border-box;
            }

            .heading {
                font-weight: 700;
                font-size: 2rem;
                color: var(--theme-white-color);
                line-height: 130%;
                margin-block-end: 1rem;
            }

            .description {
                font-size: 18px;
                color: var(--theme-white-color);
                opacity: 0.7;
                line-height: 150%;
            }

            .arrowImg {
                margin: 2rem 0 3rem;
                width: 4rem;
            }

            .buttonsWrapper {
                display: flex;
            }

            .buttonsWrapper .buttonItem {
                margin-right: 1.5rem;
                margin-bottom: 1.5rem;
            }

            .myMapsBtn {
                --btn-background-color: ${unsafeCSS(palette.aquaBlue)};
            }

            .rightContainer {
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .lockImg {
                width: 70%;
            }

            @media screen and (max-width: 960px) {
                .leftContainer {
                    width: 100%;
                }

                .heading {
                    font-size: 3rem;
                }

                .rightContainer {
                    display: none;
                }
            }

            @media screen and (max-width: 550px) {
                .leftContainer {
                    width: 100%;
                    text-align: center;
                    padding: 2rem;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                }

                .buttonsWrapper {
                    flex-wrap: wrap;
                    justify-content: space-evenly;
                    width: 100%;
                }

                .buttonsWrapper .buttonItem {
                    margin-right: 0;
                }
            }
        `;
    }
}
